/**
 * @desc 作废取消订舱计划
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(crno: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterFactoryWhole/cancel/${crno}`, {
      method: "POST",

      ...options,
    }),
  );
}
